import React from 'react';

import { List, Typography } from 'antd';
import { Trans } from 'react-i18next';

import { DateSince } from 'common-ui';
import { UserNotification } from 'core/lib';
import { MODULE_NAMES } from 'core/lib/constants';
import colors from 'core/lib/theme/colors';

import { NotificationCardModuleCreateIcon, NotificationCardWrapper } from '../components';

const { Text } = Typography;

type ModuleCreateNotificationCardProps = {
  notification: UserNotification;
  onClick: (id: number) => void;
};

const ModuleCreateNotificationCard = ({ notification, onClick }: ModuleCreateNotificationCardProps) => {
  const type = notification.objectType ? MODULE_NAMES[notification.objectType] : notification.type;

  return (
    <NotificationCardWrapper hasQueryParams={false} key={notification.id} notification={notification} onClick={onClick}>
      <List.Item.Meta
        avatar={<NotificationCardModuleCreateIcon />}
        title={
          <Trans
            i18nKey="notifications:module.create"
            shouldUnescape={true}
            values={{ objectName: notification.objectName, type }}
            components={{ linkText: <Text style={{ color: colors.Primary.rgba }}></Text> }}
          />
        }
        description={<DateSince date={notification.dateCreated} />}
      />
    </NotificationCardWrapper>
  );
};

export default ModuleCreateNotificationCard;
